import React from 'react';
import useOddForm from '../hooks/useOddForm';
import { OddFormContextState } from '../types/context';

export const OddFormContext = React.createContext<OddFormContextState>({
  isLoading: null,
  error: null,
  data: null,
});

interface Props {
  children: React.ReactNode;
}

const OddFormProvider = ({ children }: Props) => {
  const state = useOddForm();

  return (
    <OddFormContext.Provider value={{ ...state }}>
      {children}
    </OddFormContext.Provider>
  );
};

export default OddFormProvider;
